package com.trevorwiebe.timesheet.mileage.data

import dev.gitlive.firebase.storage.Data
import org.khronos.webgl.Int8Array
import org.khronos.webgl.Uint8Array

actual fun ByteArray.toFirebaseData(): Data {
    // Kotlin/JS ByteArray is backed by Int8Array at runtime
    val int8Array = unsafeCast<Int8Array>()
    return Data(Uint8Array(int8Array.buffer))
}

// Files uploaded from the Android emulator carry its 10.0.2.2 host alias, which
// only resolves inside Android; the browser reaches the emulator at localhost.
actual fun fixStorageEmulatorUrl(url: String): String =
    url.replace("://10.0.2.2:", "://localhost:")
